import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import { Box } from 'reflexbox';

import * as graphql from '@treams/treams-network';
import { PAGE_CONTENT_WIDTH, Spinner } from '@treams/treams-ui';

import FeedbackResponseComposer from '../packages/kakapo-ui-application/pages/feedback-v2/respond/FeedbackResponseComposer';

export default function Composer(props: { requestID: string }) {
	const { data, loading } = graphql.useInternalFeedbackQuery({
		variables: { id: props.requestID },
	});

	const { t } = useTranslation();

	if (loading) {
		return <Spinner centered />;
	}

	return (
		<Box p={[3, 4, 5]} maxWidth={PAGE_CONTENT_WIDTH} width="100%">
			<Helmet>
				<title>{t('feedback.composer.page.title')}</title>
			</Helmet>
			{data && (
				<FeedbackResponseComposer response={data.internalFeedback as graphql.FeedbackResponse} />
			)}
		</Box>
	);
}
